export default __webpack_public_path__ + "img/f8adeee920ae7842b0d9a9b800deabe5.svg";